import classNames from "classnames";
import Flex from "@/components-library/layout/flex";
import PropTypes from "prop-types";
import { forwardRef } from "react";

import classes from "./radio.module.scss";

const Radio = forwardRef(function Radio(
  {
    name,
    isEnabled,
    isChecked,
    label,
    value,
    size,
    onChange,
    action,
    className,
    labelClassName,
    style,
  },
  ref
) {
  return (
    <label
      className={classNames(classes.radio, className, {
        [classes.disabled]: !isEnabled,
      })}
      style={style}
    >
      <Flex
        className={classNames(classes.wrapper, classes[size], {
          [classes.disabled]: !isEnabled,
          [classes.checked]: isChecked,
        })}
      >
        {isChecked && <div className={classes.checked} />}

        <input
          ref={ref}
          type="radio"
          name={name}
          checked={isChecked}
          //onChange={isEnabled ? onChange : undefined}
          disabled={true}
          value={value}
        />
      </Flex>

      {label && (
        <span
          className={classNames(classes.label, labelClassName, classes[size])}
        >
          {label}
        </span>
      )}

      {isChecked && action && (
        <action.type {...action.props} className={classNames(classes.action)} />
      )}
    </label>
  );
});

Radio.sizes = ["xs", "sm", "md", "lg", "xl"];
Radio.propTypes = {
  size: PropTypes.oneOf(Radio.sizes).isRequired,
  name: PropTypes.string.isRequired,
  isEnabled: PropTypes.bool.isRequired,
  isChecked: PropTypes.bool.isRequired,
  label: PropTypes.node,
  value: PropTypes.string,
  onChange: PropTypes.func,
  action: PropTypes.node,
  className: PropTypes.string,
  labelClassName: PropTypes.string,
  style: PropTypes.object,
};

Radio.defaultProps = {
  size: "md",
  name: "",
  isEnabled: true,
  isChecked: false,
};

export default Radio;
